/**
 * Display keys for rollup lines — the string that says "this on-screen row and
 * these per-day rows are the same line".
 *
 * Shared because BOTH ends build it: the API stamps `display_key` on every
 * per-day row it serves, and the Rollup Detail table builds it from the line it
 * is rendering to find that line's days. If the two definitions drifted, the
 * day-explicit edit form would open on the wrong set of days — which is the
 * exact class of bug it exists to fix.
 *
 * NOT the full grouping key. compute.ts groups labor by identity + DAYPART +
 * rate triple + manual provenance; the rollup detail payload carries no
 * daypart, so this key omits it and one display key can span a day row and a
 * swing row that price alike. That is deliberate: the form lists the rows with
 * their dates and shifts and the PM picks one, instead of the server guessing.
 */

/** Labor: identity + the displayed rate triple + manual provenance. */
export function laborLineDisplayKey(line: {
  employee_id: string | null;
  employee_name: string;
  st_rate_cents: number;
  ot_rate_cents: number;
  dt_rate_cents: number;
  is_manual: boolean;
}): string {
  const identity = line.employee_id ? `id:${line.employee_id}` : `unk:${line.employee_name}`;
  const rates = `${line.st_rate_cents}|${line.ot_rate_cents}|${line.dt_rate_cents}`;
  return `${identity}|${rates}|${line.is_manual ? 'm' : 'p'}`;
}

/** Equipment: identity + rate + manual provenance (no daypart exists here, so
 *  this is also the full grouping key). */
export function equipmentLineDisplayKey(line: {
  equipment_id: string | null;
  asset_id: string;
  rate_cents: number;
  is_manual: boolean;
}): string {
  const identity = line.equipment_id ? `id:${line.equipment_id}` : `unk:${line.asset_id}`;
  return `${identity}|${line.rate_cents}|${line.is_manual ? 'm' : 'p'}`;
}
